import { isFeatureFlagEnabled } from '$lib/services/experiments';
import { experimentService } from '$lib/services/experiments/client';
import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES, AOFL_PRODUCT_UUIDS, LINK_FROM_APP_PLATFORMS } from '$lib/utils/constants';
import { app } from '$lib/stores/app/store';
import { get } from 'svelte/store';

const abcm2DesktopExperiment = ACTIVE_EXPERIMENTS.ABCM2_DESKTOP;
const abcm2MobileExperiment = ACTIVE_EXPERIMENTS.ABCM2_MOBILE;
const metadata = {
	page_name: 'abc',
	page_url: '/abc'
};

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	browserLinkFromApp2_0: {
		condition: async () => {
			// This handles iOS app users in 2.0 experience that link out to the sub page
			const isFeatureFlag2_0 = isFeatureFlagEnabled('2_0_test');
			const isIOSPlatform = get(app)?.global.linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS;
			const is2_0 =
				ProductExperienceService.AOFL_PRODUCT_UUID === AOFL_PRODUCT_UUIDS.ABCMOUSE_2_0 ||
				isFeatureFlag2_0;
			return isIOSPlatform && is2_0;
		},
		resolve: async () => {
			return await import('../_browser-2-0-variant2/Page.svelte');
		}
	},
	browserLinkFromApp: {
		condition: async () => {
			// This handles iOS app users in 1.0 experience that link out to the sub page
			return get(app)?.global.linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS;
		},
		resolve: async () => await import('../_browser/Page.svelte')
	},
	// In-app users should always be shown the in-app experience (and it should be the 1.0 version)
	inApp: {
		condition: async (config) => {
			return config.meta.inApp;
		},
		resolve: async () => {
			ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_in-app/Page.svelte');
		}
	},
	browser_2_0_Variant2: {
		condition: async (config) => {
			const isDesktopVariant2Active = await experimentService.isExperimentArmActive(
				abcm2DesktopExperiment.experimentKey,
				abcm2DesktopExperiment.variants.test2,
				metadata
			);
			const isMobileVariantActive = await experimentService.isExperimentArmActive(
				abcm2MobileExperiment.experimentKey,
				abcm2MobileExperiment.variants.test,
				metadata
			);

			const isFeatureFlag2_0 = isFeatureFlagEnabled('2_0_test');

			return isDesktopVariant2Active || isMobileVariantActive || isFeatureFlag2_0;
		},
		resolve: async () => await import('../_browser-2-0-variant2/Page.svelte')
	},
	browser_2_0_Variant1: {
		condition: async (config) => {
			const isDesktopVariant1Active = await experimentService.isAnyExperimentArmActive(
				abcm2DesktopExperiment.experimentKey,
				[abcm2DesktopExperiment.variants.test, abcm2DesktopExperiment.variants.test1],
				metadata
			);

			return isDesktopVariant1Active;
		},
		resolve: async () => await import('../_browser-2-0-variant1/Page.svelte')
	},
	lgTv: {
		condition: async (config) => {
			return config.meta.isSmartTvApp;
		},
		resolve: async () => await import('../_lg-tv/Page.svelte')
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser/Page.svelte')
	}
};

export { pageConditions };
